import { atomWithQuery } from 'jotai-tanstack-query'
import { atom } from 'jotai'
import { fetchUseCases } from '../services/useCases.service'

export const useCasesAtom = atomWithQuery(() => ({
  queryKey: ['use-cases'],
  queryFn: ({ signal }) => fetchUseCases(signal),
}))

export const enabledUseCasesAtom = atom((get) => {
  const { data } = get(useCasesAtom)
  return data?.filter((uc) => uc.enabled) ?? []
})
